<template>
	<div class="logisticslist">
		<el-card>
			<el-tabs v-model="activetab" @tab-click="GetTabData">
				<el-tab-pane :label="tab.name" :name="tab.name" v-for="tab in tabs" :key="tab.l_id">
					<span slot="label">{{ tab.name }} ({{ tab.count }})</span>
					<el-row>
						<el-col :span="17">
							<handlerbutton :handlerlist="tab.buttons" @buttonhandle="buttonhandle"></handlerbutton>
							<span style="color:transparent" v-if="tab.buttons.length < 1">占位</span>
						</el-col>
						<el-col :span="1" class="rightcol"><el-button icon="el-icon-refresh-right" circle size="mini" @click.native="ResetFilterInfo()"></el-button></el-col>
						<el-col :span="4"><el-input placeholder="搜索" v-model="searchbox" size="small" @keyup.enter.native="refreshgrid(true)"></el-input></el-col>
						<el-col :span="2" class="rightcol">
							<el-popover placement="bottom-end" :width="filterlist.length > 0 ? 500 : 350" trigger="click">
								<table class="htmltable">
									<tr>
										<td><label>订单号</label></td>
										<td><el-input type="textarea" rows="3" v-model="searchlist.p_pkval" size="mini"></el-input></td>
										<td rowspan="5" valign="top" class="filter" v-if="filterlist.length > 0">
											<div>常用筛选</div>
											<ul>
												<li v-for="(item, index) in filterlist">
													<el-radio v-model="searchlist.fixfilter" :label="item.fname" @change="Setfilterchecked">{{ item.fname }}</el-radio>
												</li>
											</ul>
										</td>
									</tr>
									<tr>
										<td><label>快递单号</label></td>
										<td><el-input type="textarea" rows="3" v-model="searchlist.expressid" size="mini"></el-input></td>
									</tr>
									<tr>
										<td><label>批次号</label></td>
										<td><el-input v-model="searchlist.p_batch" size="mini"></el-input></td>
									</tr>
									<tr>
										<td><label>商品名称</label></td>
										<td><el-input v-model="searchlist.cname" size="mini"></el-input></td>
									</tr>
									<tr>
										<td><label>下单时间</label></td>
										<td style="text-align:left;">
											<el-date-picker
												v-model="searchlist.starttime"
												type="date"
												placeholder="选择开始日期"
												size="mini"
												value-format="yyyy-MM-dd"
											></el-date-picker>
										</td>
									</tr>
									<tr>
										<td><label>至</label></td>
										<td>
											<el-date-picker
												v-model="searchlist.endtime"
												type="date"
												placeholder="选择结束日期"
												size="mini"
												value-format="yyyy-MM-dd"
											></el-date-picker>
										</td>
									</tr>
									<tr>
										<td colspan="4" class="bottombtn">
											<el-button @click="GetTabData()" type="warning" size="mini">查询</el-button>
											<el-button @click="ClearSearch(0)" size="mini">清空</el-button>
										</td>
									</tr>
								</table>

								<el-link slot="reference" type="primary">更多筛选</el-link>
							</el-popover>
						</el-col>
					</el-row>
					<el-row style="height:10px;"></el-row>
					<el-row>
						<el-col :span="24">
							<tableexpand
								v-if="tab.isgridexpand"
								style="width:100%;"
								v-loading="loading"
								ref="packagetableexpand"
								:tableData="packagelist"
								:columns="tab.columns"
								@gridhandle="gridhandle"
								:gridheight="gridheight"
								@gridsort="gridsort"
								@checkboxchange="checkboxchange"
								@gridscroll="gridscroll"
								@rowdblclick="rowdblclick"
								:istop="istop"
								:soncolumns="tab.soncolumns"
								:isexpand="isexpand"
								@getExpandsRow="getExpandsRow"
								:rowkey="rowkey"
							></tableexpand>

							<!-- <tableui
								v-else 
								style="width:100%;"
								v-loading="loading"
								ref="packagetable"
								:tableData="packagelist"
								:columns="tab.columns"
								@gridhandle="gridhandle"
								:gridheight="gridheight"
								@gridsort="gridsort"
								@checkboxchange="checkboxchange"
								@gridscroll="gridscroll"
								@rowdblclick="rowdblclick"
								:istop="istop"
							></tableui>
						 -->
						</el-col>
					</el-row>
				</el-tab-pane>
			</el-tabs>
		</el-card>

		<printhandler ref="printhandler"></printhandler>
		<pastorderwin ref="pastorderwin" @pastorderhandler="pastorderhandler"></pastorderwin>
		<exportwin ref="exportwin"></exportwin>
		<updateweight ref="updatew"></updateweight>
		<importwin ref="importwin"></importwin>
		<reperview ref="reperview"></reperview>
		<createstep ref="createstep"></createstep>
		<pushwl ref="pushwl"></pushwl>
	</div>
</template>
<script>
import handlerbutton from '@/components/handlerbutton/handler.vue';
//import tableui from '@/components/table/tablegrid.vue';
import tableexpand from '@/components/table/tablegrid_expand.vue';
import Utils from '../../lib/util.js';
import pastorderwin from '@/components/order/pastorderwin.vue';
import printhandler from '@/components/order/printhandler.vue';
import exportwin from '@/components/order/exportwin.vue';
import updateweight from '@/components/order/updateweight.vue'; //称重并计费
import importwin from '@/components/order/importwin.vue'; //万能导入
import reperview from '@/components/order/reperview.vue'; //重打
import createstep from '@/components/orderset/createstep.vue';//生成物流
import pushwl from '@/components/order/pushwl.vue';//推送物流
export default {
	components: {
		//tableui,
		tableexpand,
		handlerbutton,
		pastorderwin,
		printhandler,
		exportwin,
		updateweight,
		importwin,
		reperview,
		createstep,
		pushwl
	},
	data() {
		return {
			searchlist: {
				p_pkval: '',
				expressid: '',
				p_batch: '',
				cname: '',
				starttime: '',
				endtime: '',
				fixfilter: '',
				fixsort: ''
			},
			istop: false,
			searchbox: '',
			type: '',
			pickerOptions: '',
			packagelist: [],
			gridheight: (window.innerHeight * 66) / 100 + 'px',
			activeName: '',
			activetab: '',
			activeTabIndex: 0, //激活的选项卡index
			loading: false,
			pageindex: 0,
			pagesize: 200,
			search: '',
			sort: '',
			tabs: [],
			mode: '物流管理', //当前操作的功能模块名称
			filterlist: [], //常用筛选条件
			selectedall: false,
			checkedrow: [],
			batch: '',
			divclass: 'logisticslist',
			showpdf: '',
			showsuccesswin: false,
			isloadscroll: false,
			rowkey: 'groupid',
			isexpand: false, //默认展开
			soncolumns: [],
			sendcode:''//推送物流方法
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/logisticsmanager/logisticscss.scss');
			this.getTabs();
		});
		var that = this;
		Utils.$on('refreshgrid', function(msg) {
			that.refreshgrid(true);
		});
	},
	methods: {
		//获取选项卡
		getTabs() {
			var that = this;
			this.$apipost.get.GetTabs({ parentid: 64 }).then(res => {
				if (res.tabs != undefined) {
					res.tabs.forEach(e => {
						e.isgridexpand = false;
						if (e.type.indexOf('_expand') > -1) {
							e.isgridexpand = true;
						}
					});
					that.tabs = res.tabs;
					let tab = this.tabs[0];
					that.activeName = tab.type;
					that.activetab = tab.name;
					that.GetTabData({index:0});
				} else {
					that.getTabs();
				}
			});
		},
		//清空筛选条件
		ClearSearch(type) {
			this.searchlist = {
				p_pkval: '',
				expressid: '',
				p_batch: '',
				cname: '',
				starttime: '',
				endtime: '',
				fixfilter: '',
				name: ''
			};
			if (type == 1) {
				this.searchbox = '';
			}
		},
		//获取表头方法
		GetTabData(tab) {
			if (tab != undefined) {
				this.activeTabIndex = tab.index;
				this.activeName = this.tabs[this.activeTabIndex].type;
				this.activetab = this.tabs[this.activeTabIndex].name;
				
				this.GetFilter(); //加载选项卡对应的筛选条件
				this.GetPackageCount(); //获取汇总数
				if (this.tabs[this.activeTabIndex].columns.length == 0) {
					this.GetColumns();
				} else {
					this.refreshgrid(true);
				}
			}
			else{
				this.refreshgrid(true);
			}
		},
		//滚动加载列表
		gridscroll(e) {
			if (e != undefined) {
				var that = this;
				const scrollDistance = e.event.target.scrollHeight - e.e.scrollTop - e.event.target.offsetHeight;
				console.log(scrollDistance);
				if (scrollDistance <= 120) {
					that.refreshgrid(false);
				}
			}
		},
		//刷新列表
		refreshgrid(isrefresh) {
			var that = this;
			this.istop = false;
			var isload = true;
			if (isrefresh) {
				this.packagelist = [];
				this.checkedrow = [];
				//刷新
				this.pageindex = 0;
				this.istop = true;
			} else {
				//加载下一页
				if (parseInt(this.tabs[this.activeTabIndex].pagecount - 1) > this.pageindex) {
					this.pageindex = this.pageindex + 1;
				} else {
					isload = false;
				}
			}
			if (isload) {
				this.loading = true;
				var paraminfo = {
					search: this.GetSearchObj(),
					tab: this.tabs[this.activeTabIndex].type,
					pageindex: this.pageindex,
					pagesize: this.pagesize,
					sort: this.sort,
					showcol: JSON.stringify(this.tabs[this.activeTabIndex].columns),
					l_mode: this.mode,
					iscount: 0,
					userid: localStorage.getItem('userid')
				};
				//debugger
				this.$apipost.get.GetOrderList({ paraminfo: JSON.stringify(paraminfo) }).then(res => {
					//console.log('res',JSON.stringify(res.data));
					that.loading = false;
					if (isload && !that.isloadscroll) {
						that.gridscroll();
					}
					res.data=that.SetGridChild(res.data);
					if (res.data.length > 0) {
						if (that.pageindex > 0) {
							// if (that.tabs[that.activeTabIndex].isgridexpand) {
							// 	this.$nextTick(function() {
							// 		that.$refs.packagetableexpand[that.activeTabIndex].init({ list: res.data, isrefresh: isrefresh });
							// 	});
							// }
							that.packagelist = that.packagelist.concat(res.data);
						} else {
							// if (that.tabs[that.activeTabIndex].isgridexpand) {
							// 	this.$nextTick(function() {
							// 		if(that.$refs.packagetableexpand.length>0)
							// 			that.$refs.packagetableexpand[that.activeTabIndex].init({ list: res.data, isrefresh: isrefresh });
							// 	});
							// }
							that.packagelist = res.data;
						}
					}
					if(that.$refs.packagetableexpand.length>0)
						that.$refs.packagetableexpand[that.activeTabIndex].SetTableList(that.packagelist,isrefresh);
				});
				if(isrefresh)
					that.GetPackageCount(); //获取汇总数
			}
		},
		SetGridChild(list){
			list.forEach(e=>{
				if(e.haschild=='1')
					e.sonDataList=[];
			});
			return list;
		},
		//组合筛选条件
		GetSearchObj() {
			var search = JSON.parse(JSON.stringify(this.searchlist));
			if (search.fixfilter != '') {
				var that = this;
				var searchtype = '';
				this.filterlist.forEach(e => {
					if (e.fname == search.fixfilter) {
						if (e.handlertype == 'filter') {
							searchtype = e.searchtype;
							return false;
						} else if (e.handlertype == 'sort') {
							searchtype = '';
							search.fixfilter = '';
							search.fixsort = e.filter;
							return false;
						}
					}
				});
				search.searchtype = searchtype;
			}
			search.p_pkval = search.p_pkval.replace(/\n/g, ',');
			search.expressid = search.expressid.replace(/\n/g, ',');
			if (this.searchbox != '') {
				search.searchbox = this.searchbox;
			}
			return JSON.stringify(search);
		},
		//获取列配置信息
		GetColumns() {
			var that = this;
			this.$apipost.get.GetColumns({ tab: this.tabs[this.activeTabIndex].type, checkfield: 1, parentid: this.tabs[this.activeTabIndex].id, mode: this.mode }).then(res => {
				//console.log('列配置',JSON.stringify(res));
				that.tabs[that.activeTabIndex].columns = res;
				if (that.tabs[this.activeTabIndex].type.indexOf('_expand') > -1) {
					//设置子表的列配置，去掉勾选、去掉模板列
					var colums = res.filter(function(e) {
						return e.type != '' && e.type != 'template';
					});
					that.tabs[that.activeTabIndex].soncolumns = colums;
				}
				that.refreshgrid(true);
			});
		},
		//获取包裹管理汇总表
		GetPackageCount() {
			var that = this;
			var type = this.tabs[this.activeTabIndex].type;
			this.$apipost.get.GetLogisticsCount({ tab: type, search: this.GetSearchObj() }).then(res => {
				if (res.state == '1') {
					for (var i = 0; i < that.tabs.length; i++) {
						var countlist = res.countlist[0];
						for (var e in countlist) {
							if (e == that.tabs[i].type) {
								that.tabs[i].count = countlist[e];
								break;
							}
						}
					}
					that.setpagecount();
				}
			});
		},
		//设置分页显示数
		setpagecount() {
			var tabs = this.tabs;
			tabs.forEach(e => {
				if (parseInt(e.count) % this.pagesize == 0) {
					e.pagecount = parseInt(e.count) / this.pagesize;
				} else {
					e.pagecount = parseInt(parseInt(e.count) / this.pagesize) + 1;
				}
			});
		},
		//列表排序
		gridsort(e) {
			//e.column.prop--排序列名
			//e.column.order--ascending/descending --排序方式
			this.sort = ' ' + e.column.prop + ' ' + e.column.order.replace('ending', '');
			this.refreshgrid(true);
		},
		//操作栏按钮触发事件
		buttonhandle(e) {
			var that = this;
			if (e.event == 'Inportorder') {
				//导入
				this.InportOrder(e);
			}
			if (e.event == 'delorder') {
				this.DelOrder(e);
			}
			if (e.event == 'printorder') {
				//按权限匹配打印模板的方式来打印，直接控件打印出来
				var searinfo = that.GetCheckedOrder(true);
				//debugger
				if (searinfo != '') {
					this.$tool.loading('正在' + e.title, 'packagelist');
					if (that.$refs.printhandler != undefined) {
						that.$refs.printhandler.init({
							pageparam: this._data,
							isgrid: true,
							pkval: '',
							searchinfo: searinfo,
							funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
							handtype: 13, //1--取单号 2--取快递单并打印 3-取快递单并预览
							isrollback: false,
							parentpage: this,
							isprint: 1
						});
					}
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '打印',
							l_id: e.l_id
						});
					}
				}
			}
			if (e.event == 'perviewprint') {
				//按权限匹配打印模板的方式来打印，直接控件打印出来
				var searinfo = that.GetCheckedOrder(true);
				//debugger
				if (searinfo != '') {
					this.$tool.loading('正在' + e.title, this.divclass);
					if (that.$refs.printhandler != undefined) {
						that.$refs.printhandler.init({
							pageparam: this._data,
							isgrid: true,
							pkval: '',
							searchinfo: searinfo,
							funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
							handtype: 12, //1--取单号 2--取快递单并打印 3-取快递单并预览
							isrollback: false,
							parentpage: this,
							isprint: 0
						});
					}
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '预览',
							l_id: e.l_id
						});
					}
				}
			}
			if (e.event == 'intercept') {
				//拦截
				var searinfo = that.GetCheckedOrder(true);
				if (searinfo != '') {
					if (that.$refs.interceptwin != undefined) {
						that.$refs.interceptwin.init({ searchinfo: searinfo, pageparam: this._data });
					}
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '拦截',
							l_id: e.l_id
						});
					}
				}
			}
			if (e.event == 'cancelintercept') {
				var searinfo = that.GetCheckedOrder(true);
				if (searinfo != '') {
					that.Cancelintercept({ searchinfo: searinfo, pageparam: this._data });
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '取消拦截',
							l_id: e.l_id
						});
					}
				}
			}
			if (e.event == 'exportorder_zdy') {
				this.ExportOrder();
			}
			if (e.event == 'allimport') {
				if (that.$refs.importwin != undefined) {
					that.$refs.importwin.init({
						mode: '',
						dialogtitle: e.l_name
					});
				}
			}
			if (e.event == 'getwl') {
				this.Getwl_Batch();
			}
			if (e.event == 'updateweight') {
				if (this.selectedall) {
					if (this.packagelist.length == 1) this.$refs.updatew.init({ pkval: this.packagelist[0].p_pkval });
					else if (this.packagelist.length > 1) this.$tool.message('请勾选一条数据进行操作', 0);
					else this.$refs.updatew.init({ pkval: '' });
				} else {
					if (this.checkedrow.length > 1) {
						this.$tool.message('请勾选一条数据进行操作', 0);
					} else {
						if (this.checkedrow.length == 1) this.$refs.updatew.init({ pkval: this.checkedrow[0].p_pkval });
						else this.$refs.updatew.init({ pkval: '' });
					}
				}
			}
			if (e.event == 'buchajia') {
				//补差价导入
				if (that.$refs.importwin != undefined) {
					that.$refs.importwin.init({
						mode: '',
						dialogtitle: e.l_name
					});
				}
			}
			if (e.event == 'reperview') {
				//预览面单(仅可预览官方单和订单本身的快递面单)
				var searinfo = that.GetCheckedOrder(false);
				//debugger
				if (searinfo != '') {
					this.$tool.loading('正在' + e.title, this.divclass);
					if (that.$refs.reperview != undefined) {
						that.$refs.reperview.init({
							searchinfo: searinfo,
							pageparam: that._data,
							handtype: 12
						});
					}
				}
			}
			//生成物流
			if(e.event=='createstep'){
				var searinfo = that.GetCheckedOrder(true);
				if(searinfo!=''){
					var paraminfo=JSON.parse(JSON.stringify(this._data));
						paraminfo.searchinfo=searinfo;
					if(that.$refs.createstep!=undefined)
						that.$refs.createstep.init({pageparam:paraminfo});
				}else{
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '生成物流',
							l_id: e.l_id
						});
					}
				}
			}
			//推送物流
			if(e.event=='pushwl'){
				var searinfo = that.GetCheckedOrder(true);
				if(searinfo!=''){
					var pageparam=that._data;
					pageparam.searchinfo=searinfo;
					if(that.$refs.pushwl!=undefined)
						that.$refs.pushwl.init({searchinfo:searinfo,pageparam:pageparam});
				}else{
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '推送物流',
							l_id: e.l_id
						});
					}
				}
			}
			if (e.event == 'getmailno') {
				var searinfo = that.GetCheckedOrder(true);
				//debugger
				if (searinfo != '') {
					this.$tool.loading('正在' + e.title, this.divclass);
					if (that.$refs.printhandler != undefined) {
						that.$refs.printhandler.init({
							pageparam: this._data,
							isgrid: true,
							pkval: '',
							searchinfo: searinfo,
							funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
							handtype: 11, //11--取单号
							isrollback: false,
							parentpage: this,
							isprint: 0
						});
					}
				} else {
					if (that.$refs.pastorderwin != undefined) {
						that.$refs.pastorderwin.init({
							l_mode: that.mode,
							fun: '取单号',
							l_id: e.l_id
						});
					}
				}
			}
		},
		//列表中的自定义列的操作事件
		gridhandle(e) {
			this.checkedrow = [];
			if (e.event == 'delorder') {
				this.checkedrow.push(this.packagelist[e.index]);
				this.DelOrder();
			}
			if (e.event == 'editorder') {
				Utils.$emit('go', { l_url: '/packagemanange/createorder', l_id: e.l_id, l_name: '修改订单', urlparam: { pkval: this.packagelist[e.index].p_pkval, iscopy: 0 } });
			}
			if (e.event == 'copyorder') {
				var that = this;
				this.$apipost.get.GetLinkInfo({ l_id: e.l_id }).then(res => {
					that.showratewin = false;
					if (res.info != undefined) {
						Utils.$emit('go', {
							l_url: '/packagemanange/createorder_pkg',
							l_id: e.l_id,
							l_name: '复制订单',
							urlparam: { pkval: that.packagelist[e.index].p_pkval, iscopy: 1, l_tablename: res.info.l_tablename }
						});
					} else that.$tool.message('', 0);
				});
			}
			if (e.event == 'showdetail') {
				Utils.$emit('go', { l_url: '/packagemanange/orderdetail', l_id: e.l_id, l_name: '订单详情', urlparam: { pkval: this.packagelist[e.index].p_pkval, iscopy: 0 } });
			}
		},
		//获取常用筛选条件
		GetFilter() {
			var that = this;
			this.$apipost.get.GetFilter({ l_mode: this.mode, type: this.tabs[this.activeTabIndex].type }).then(res => {
				if (res != '') {
					that.filterlist = res.data;
				}
			});
		},
		//设置常用筛选
		Setfilterchecked(value) {
			this.searchlist.fixfilter = value;
		},
		//复选框勾选触发
		checkboxchange(e) {
			if (!e.selectedall) {
				this.checkedrow = e.rows; //勾选了的列表
			}
			this.selectedall = e.selectedall;
		},
		//导入订单
		InportOrder(e) {
			//导入订单
			Utils.$emit('go', {
				l_url: '/packagemanange/orderimport',
				l_name: '批量下单',
				l_id: e.l_id,
				urlparam: { tab: this.tabs[this.activeTabIndex].type, mode: '包裹管理导入', l_name: '批量下单' }
			});
		},
		//删除订单方法1/2
		DelOrder(e) {
			var searchinfo = this.GetCheckedOrder(true);
			if (searchinfo != '') {
				var that = this;
				this.$confirm('确定删除所选订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				})
					.then(() => {
						//debugger
						this.$tool.loading('正在获取勾选数据', this.divclass);
						this.$apipost.post.InsertTemp({ l_mode: that.mode, tab: that.tabs[that.activeTabIndex].type, search: searchinfo, sort: that.sort }).then(res => {
							this.$tool.loadingclose();
							if (res != '') {
								if (res.batch != '') {
									this.$tool.loading('正在删除', this.divclass);
									that.DelOrder2(res.batch);
								} else {
									this.$tool.message('获取数据失败', 0);
								}
							} else {
								this.$tool.message('获取数据失败', 0);
							}
						});
					})
					.catch(() => {});
			} else {
				if (that.$refs.pastorderwin != undefined) {
					that.$refs.pastorderwin.init({
						l_mode: that.mode,
						fun: '删除'
					});
				}
			}
		},
		//删除订单方法2/2
		DelOrder2(batch) {
			var that = this;
			console.log('删除订单', batch);
			console.log('this.mode', this.mode);
			this.$apipost.post.SetOrderToTrash({ l_mode: this.mode, batch: batch, pkval: '', type: 1 }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('操作成功', 1);
					that.refreshgrid(true);
					that.GetPackageCount(); //获取汇总数
				} else {
					this.$tool.message(res.message, 0);
				}
			});
		},
		//重置筛选
		ResetFilterInfo() {
			this.ClearSearch(1); //先清空筛选条件
			this.refreshgrid(true);
		},
		//获取勾选数据组合json
		GetCheckedOrder(isempty) {
			var pkval = '';
			var isgo = true;
			var search = {
				p_pkval: ''
			};
			var searchinfo = '';
			if (!this.selectedall) {
				if (this.tabs[this.activeTabIndex].isgridexpand) {
					this.checkedrow.forEach(e => {
						pkval += e.groupid + ',';
					});
					if (pkval != '') {
						pkval = pkval.substring(0, pkval.length - 1);
						search.groupid = pkval; //这里的筛选条件对象的结构与订单筛选条件结构一致
						searchinfo = JSON.stringify(search);
					} else {
						if (!isempty) this.$tool.message('请勾选订单', 2);
					}
				} else {
					this.checkedrow.forEach(e => {
						pkval += e.p_pkval + ',';
					});
					if (pkval != '') {
						pkval = pkval.substring(0, pkval.length - 1);
						search.p_pkval = pkval; //这里的筛选条件对象的结构与订单筛选条件结构一致
						searchinfo = JSON.stringify(search);
					} else {
						if (!isempty) this.$tool.message('请勾选订单', 2);
					}
				}
			} else {
				searchinfo = this.GetSearchObj();
			}
			return searchinfo;
		},
		//粘贴获取订单
		pastorderhandler(e) {
			if (e.fun == '打印') {
				this.$tool.loading('正在打印', this.divclass);
				if (this.$refs.printhandler != undefined) {
					this.$refs.printhandler.init({
						pageparam: this._data,
						isgrid: true,
						pkval: '',
						searchinfo: '',
						funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
						handtype: 13, //1--取单号 2--取快递单并打印 3-取快递单并预览
						isrollback: false,
						parentpage: this,
						batch: e.checkedbatch,
						isprint: 1
					});
				}
			}
			if (e.fun == '取单号') {
				this.$tool.loading('正在获取', this.divclass);
				if (this.$refs.printhandler != undefined) {
					this.$refs.printhandler.init({
						pageparam: this._data,
						isgrid: true,
						pkval: '',
						searchinfo: '',
						funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
						handtype: 11, //1--取单号 2--取快递单并打印 3-取快递单并预览
						isrollback: false,
						parentpage: this,
						batch: e.checkedbatch,
						isprint: 0
					});
				}
			}
			if (e.fun == '预览') {
				this.$tool.loading('正在预览', this.divclass);
				if (this.$refs.printhandler != undefined) {
					this.$refs.printhandler.init({
						pageparam: this._data,
						isgrid: true,
						pkval: '',
						searchinfo: '',
						funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
						handtype: 12, //1--取单号 2--取快递单并打印 3-取快递单并预览
						isrollback: false,
						parentpage: this,
						batch: e.checkedbatch,
						isprint: 0
					});
				}
			}
			
			if (e.fun == '删除') {
				var batch = e.checkedbatch;
				this.$confirm('确定删除输入的订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.DelOrder2(batch);
				});
			}
			if (e.fun == '自定义导出') {
				var batch = e.checkedbatch;
				if (this.$refs.exportwin != undefined) {
					this.$refs.exportwin.init({
						batch: batch,
						pageparam: this._data,
						handtype: 1
					});
				}
			}
			if (e.fun == '拦截') {
				if (that.$refs.interceptwin != undefined) {
					that.$refs.interceptwin.init({
						batch: e.checkedbatch,
						pageparam: this._data
					});
				}
			}
			if (e.fun == '取消拦截') {
				that.Cancelintercept({ batch: e.checkedbatch });
			}
			if (e.fun == '导出') {
				var batch = e.checkedbatch;
				if (this.$refs.exportwin != undefined) {
					this.$refs.exportwin.init({
						batch: batch,
						pageparam: this._data,
						handtype: 1
					});
				}
			}
			if(e.fun=='生成物流')
			{
				var batch=e.checkedbatch;
				if(this.$refs.createstep!=undefined)
					this.$refs.createstep.init({batch:batch});
			}
			if(e.fun=='推送物流')
			{
				var batch=e.checkedbatch;
				if(this.$refs.pushwl!=undefined)
					this.$refs.pushwl.init({batch:batch,sendcode:this.sendcode,pageparam:this._data});
			}
		},
		//取消拦截
		Cancelintercept(paraminfo) {
			var that = this;
			this.$tool.loading('正在取消拦截', this.divclass);
			this.$apipost.post.Cancelintercept({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message(res.message, 1);
				} else {
					this.$tool.message(res.message, 0);
				}
			});
		},
		//列表双击事件
		rowdblclick(e) {
			Utils.$emit('go', { l_url: '/packagemanange/orderdetail', l_id: '', l_name: '订单详情', urlparam: { pkval: e.row.p_pkval, iscopy: 0 } });
		},
		//导出
		ExportOrder() {
			var that = this;
			var searchinfo = this.GetCheckedOrder(true);
			if (searchinfo != '') {
				if (that.$refs.exportwin != undefined) {
					that.$refs.exportwin.init({
						searchinfo: searchinfo,
						pageparam: that._data,
						handtype: 1
					});
				}
			} else {
				if (that.$refs.pastorderwin != undefined) {
					that.$refs.pastorderwin.init({
						l_mode: that.mode,
						fun: '自定义导出'
					});
				}
			}
		},
		Getwl_Batch(){
			var that=this;
			var searinfo = that.GetCheckedOrder(false);
			if(searinfo!=''){
				var paraminfo={
					pageparam:this._data,
					searchinfo: searinfo
				}
				this.$tool.loading('正在查询', this.divclass);
				setTimeout(function(){that.$tool.loadingclose();},2000);
				this.$apipost.get.Getwl_Batch({ paraminfo: paraminfo }).then(res => {
					if(res.state=='0'){
						that.$tool.loadingclose();
						this.$tool.message(res.message, 0);
					}
					console.log('res',res);
				});
			}
		},
		//列表展开时加载子表信息
		getExpandsRow(e) {
			e.row.expand = e.expand;
			if (e.expand) {
				//加载子表信息
				this.loadsongrid(e.row, e.index);
			}
		},
		loadsongrid(row, index) {
			var that = this;
			var search = {
				groupid: row.groupid
			};
			this.loading = true;
			var paraminfo = {
				search: search,
				tab: this.tabs[this.activeTabIndex].type,
				pageindex: 0,
				pagesize: 100,
				sort: this.sort,
				showcol: JSON.stringify(this.tabs[this.activeTabIndex].soncolumns),
				l_mode: this.mode + '子表',
				iscount: 0,
				userid: localStorage.getItem('userid')
			};
			this.$apipost.get.GetOrderList({ paraminfo: JSON.stringify(paraminfo) }).then(reslist => {
				//debugger
				//console.log('子表',JSON.stringify(reslist.data));
				that.packagelist[index].sonDataList=reslist.data;
				that.loading = false;
				that.$refs.packagetableexpand[that.activeTabIndex].SetExpandSonList(index, reslist.data);
			});
		}
	}
};
</script>
